import React from 'react'
import Select from 'components/Select'
import { animateScroll } from 'components/ScrollTo'
import type { ConnectorProps as HitsPerPageConnectorProps } from 'connectors/Algolia/HitsPerPage'
import HitsPerPageConnector from 'connectors/Algolia/HitsPerPage'
import { updateFeatureUrl } from '../helpers/url'
import type { ConnectorProps as URLProps } from '../connectors/Url'
import URLConnector from '../connectors/Url'
const OPTIONS = [25, 50, 100]
const DEFAULT_HITS_PER_PAGE = 50
type Props = HitsPerPageConnectorProps & URLProps

const Component = (props: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const { hitsPerPage, getHref } = props
  return (
    <Select
      onChange={(value: number) => {
        const params = {
          hitsPerPage: value,
          page: '', // Reset Page
        }
        animateScroll({
          offset: 0,
          duration: 200,
        })
        const href = getHref(params)
        updateFeatureUrl(href)
      }}
      value={hitsPerPage || DEFAULT_HITS_PER_PAGE}
      aria-label='Results per page'
    >
      {OPTIONS.map((num) => (
        <option key={num} value={num}>
          {num} Results Per Page
        </option>
      ))}
    </Select>
  )
}

export default HitsPerPageConnector(URLConnector(Component))